import {darkGray, white} from '@modifi/colors'
import {Col} from '@modifi/ui'
import styled, {css, FlattenSimpleInterpolation} from 'styled-components'

export const HoverCardWrapper = styled(Col)`
  text-wrap: wrap;
  position: relative;
`

type MainContentProps = {
  isHovered: boolean
}

export const MainContent = styled.div<MainContentProps>`
  h5,
  p {
    ${({isHovered}): FlattenSimpleInterpolation | string => (isHovered ? `color: ${white};` : '')}
    transition: color 0.5s ease-in-out;
  }

  img {
    width: 100%;
    object-fit: cover;
  }
`

type SlidingContentProps = {
  isHovered: boolean
  height: number
}

export const SlidingContent = styled.div<SlidingContentProps>`
  background: linear-gradient(to top, ${white}, rgba(255, 255, 255, 0.75));
  color: ${darkGray};
  border-radius: 8px 8px 0 0;
  padding: 16px;
  width: calc(100% - 30px);
  pointer-events: none;
  position: absolute;
  bottom: 0;
  z-index: 10;
  transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
  opacity: 0;
  transform: ${({height}): string | number => height && `translateY(${height}px)`};
  ${({isHovered}): string | FlattenSimpleInterpolation =>
    isHovered
      ? css`
          transform: translateY(0);
          opacity: 1;
        `
      : ''}
`
